import StarsBanner from "~/ui/stars-banner";
import { icon, node, text } from "~/util/dom";

/**
 * @private
 */
export default class SelectBox {
	_node: HTMLDivElement;

	_button: HTMLButtonElement;

	_list: HTMLUListElement;

	_items: Array<HTMLLIElement>;

	_data: {
		label: string;
		type: string;
		actions: Array<{
			label: string;
			id: string;
		}>;
	};

	_cb: (data: any) => void;

	constructor(data) {
		this._node = node("div", { className: "selectbox-filter" });
		this._button = node("button", { type: "button", className: "ratings-filter", title: data.subLabel }, data.label);
		this._list = node("ul");
		this._items = [];
		this._data = data;
		this._cb = null;
		this._build();
	}

	destroy() {
		this._cb = null;
		this._items = [];

		this._node.removeEventListener("click", this, false);
		this._list.removeEventListener("click", this, false);
	}

	get node() {
		return this._node;
	}

	set cb(fc) {
		this._cb = fc;
	}

	set select(id: string) {
		const li = this._list.querySelector(`li[data-id=${id}]`) as HTMLLIElement;

		if (li) {
			this._buttonContent(node("span", {}, li.innerText));
			this._button.classList.add("active");
		}
	}

	handleEvent(event) {
		if (event.target === this._button || this._button.contains(event.target)) {
			event.stopPropagation();
			this._toggleList();
		} else if (event.target === this._list || this._list.contains(event.target)) {
			event.stopPropagation();
			let id = "";
			let li = event.target;

			if (event.target.dataset.id) {
				id = event.target.dataset.id;
			} else {
				li = event.target.closest("li");
				id = li.dataset.id;
			}

			if (li === this._list.firstChild) {
				this._buttonContent();
				this._button.classList.remove("active");
				id = "";
			} else {
				this._buttonContent(node("span", {}, li.innerText));
				this._button.classList.add("active");
			}

			this._cb && this._cb({
				id,
				type: this._data.type,
				name: this._data.type,
				on: id !== "",
			});

			this._toggleList(true);
		} else {
			this._toggleList(true);
		}
	}

	_build() {
		this._data.actions.forEach(action => {
			const item = node("li", {}, action.label);
			const perc = action.id.match(/\d+/u);

			item.dataset.id = action.id;

			if (perc && perc.length) {
				const starsBanner = new StarsBanner({
					percentage: parseInt(perc[0]),
					space: 0,
					size: 16,
				});

				item.appendChild(starsBanner.container);
			}

			this._list.appendChild(item);

			this._items.push(item);
		});

		this._node.addEventListener("click", this, false);

		this._buttonContent();

		this._node.appendChild(this._button);
	}

	_buttonContent(contentNode?) {
		Mapy.Util.clear(this._button);
		this._button.appendChild(text(this._data.label));

		if (contentNode) {
			this._button.appendChild(contentNode);
		}
		this._button.appendChild(icon("select-down"));
	}

	_toggleList(close = false) {
		if (this._list.parentNode || close) {
			this._list.remove();
			window.removeEventListener("click", this, false);
		} else {
			this._list.style.minWidth = `${this._button.offsetWidth}px`;
			this._node.appendChild(this._list);
			window.addEventListener("click", this, false);
		}
	}
}
